import { PresentTypeCode, UserLevel } from "project-config/constants";
import { BindActivityInfo, BindHangTags, LotteryActivityInfo } from "../types";
import { accAdd, accDiv, accMul } from "project-config/utils/acc";

// 充值规则
export const rulesContentList = (
  activityInfo: BindActivityInfo,
  isZh: boolean
) => {
  const rulesText = !isZh ? activityInfo?.rulesEn : activityInfo?.rulesCn;
  return rulesText?.split("\n") ?? [];
};

// 赠送方式 0按金额1按比例
export const isByPercent = (activityInfo?: BindActivityInfo) => {
  return activityInfo?.presentType === PresentTypeCode.Proportion;
};

// 活动内容的金额是否都是一样的
export const isActivityAmountAllSame = (activityInfo?: BindActivityInfo) => {
  const { activityDetail = [] } = activityInfo || {};
  if (activityDetail.length === 0) {
    return false;
  }
  return activityDetail.every((i) => i.amount === activityDetail[0].amount);
};

// 按比例或按金额赠送的内容，最后与封顶比较
export const presentAmountCalculate = (
  activityInfo: BindActivityInfo,
  amount: number,
  presentamount?: number
) => {
  const maxCoupon = activityInfo.maxCouponAmount;
  if (presentamount) {
    const welfareAmount = isByPercent(activityInfo)
      ? Math.ceil(accDiv(accMul(amount, presentamount), 100))
      : presentamount;
    return maxCoupon && welfareAmount && welfareAmount > maxCoupon
      ? maxCoupon
      : welfareAmount;
  }
};

// 根据充值金额返回活动详情中对应符合的卡片内容，无符合返回0
export const findWelfareData = (
  activityInfo: BindActivityInfo,
  amount: number
) => {
  const detail = activityInfo.activityDetail;
  const findRechargeIndex = detail.findIndex(
    (p) => p.amount && p?.amount > amount
  );
  const welfareData =
    findRechargeIndex > 0
      ? detail[findRechargeIndex - 1]
      : findRechargeIndex === 0
      ? 0
      : detail[detail.length - 1];
  return welfareData;
};

// 动画升级的等级
export const rechargeLevel = (
  HangTags: BindHangTags[],
  isDomestic: boolean,
  userCumulative: number,
  amount?: number,
  userLevel?: number
) => {
  if (!amount) return;
  const v = isDomestic ? "rmbCumulative" : "usdCumulative";
  const findLevelIndex = HangTags.findIndex(
    (p: BindHangTags) =>
      p[v] > Number(accAdd(amount, userCumulative).toFixed(2))
  );
  return findLevelIndex > 0
    ? HangTags[findLevelIndex - 1].level
    : findLevelIndex === 0
    ? userLevel
    : UserLevel.Diamond;
};

// 根据充值金额计算抽奖券张数
export const getLotteryNumber = (
  luckDrawGiftActivityInfo: BindActivityInfo,
  lotteryActivityInfoList: LotteryActivityInfo[],
  amount: number
) => {
  const { amount: lotteryAmount, lotteryCount } =
    luckDrawGiftActivityInfo.activityDetail[0];
  if (amount < (lotteryAmount || 5000)) return 0;
  const lotteryNumber = Math.floor(
    ((amount || 1) / (lotteryAmount || 5000)) * (Number(lotteryCount) || 1)
  );
  const alreadyExistsCoupon = lotteryActivityInfoList
    ? lotteryActivityInfoList.filter((item) => item.payRecordId).length
    : 0;
  if (
    luckDrawGiftActivityInfo.maxCouponAmount &&
    luckDrawGiftActivityInfo.maxCouponAmount - alreadyExistsCoupon &&
    lotteryNumber
  ) {
    return lotteryNumber >
      (luckDrawGiftActivityInfo.maxCouponAmount - alreadyExistsCoupon || 0)
      ? luckDrawGiftActivityInfo.maxCouponAmount - alreadyExistsCoupon
      : lotteryNumber;
  }
  return 0;
};
